

// THIS MODEL IS NOT CRECT AND NEEDS UPDATING (think I updated it and works.)

// tslint:disable-next-line:quotemark
 import {Deserializable} from "./deserializable.model";

export class SystemFile {
  public job_id?: number;

  public file_id?: number;
  public file_name?: string;
  public file_display_name?: string;
  public file_ext?: string;
  public file_server_location?: string;
  public file_url?: string;
  public file_folder?: string;
  public file_make?: string;
  public file_notes?: string;
  public file_job_id?: number;
  public file_subject_id?: number;
  public file_subject_number?: string;
  public created_by?: number;
  public created_date?: any;
  public created_level?: number;
  public file_brand_id?: number;
  public file_access_level?: number;
  public is_active?: string;
  public file_password?: string;
  public file_edit_level?: number;
  public updated_by?: number;
  public updated_date?: string;
  public prev_file_id?: number;
  public brand_type_id?: number;
  public subject_template_doc_id?: number;
  public subject_com_type_id?: number;
  public random_file_name?: string;
  public full_file_name?: string;

  // public agent_access_array?: any = []; // collect current agent ids
 agent_access_array?: any; // collect current agent ids
 report_access_array?: any = []; // collect client
 invoice_access_array?: any = []; // collect client
 user_access_array?: any = []; // of selected associated users.


// file upload - ng- drop - model changed to this so added to validate.
public type?: any; // file type eg mpgs
public size?: number;
public name?: any;  // of upload file array

public systemFile_HTML?;
public is_theme?: boolean;
public  assigned_to_agents?: string;
  

/*
  file_id
  file_name
  file_display_name
  file_ext
  file_server_location
  file_url
  file_folder
  file_make
  file_notes
  file_job_id
  file_subject_id
  file_subject_number
  created_by
  created_date
  created_level
  file_brand_id
  file_access_level
  is_active
  file_password
  file_edit_level
  updated_by
  updated_date
  prev_file_id
  brand_type_id
  subject_template_doc_id
  subject_com_type_id
  random_file_name
  full_file_name
  agent_access_array
  report_access_array
  invoice_access_array
  user_access_array

*/

/* 
  // ? what does this really do? (no encoding or deserialisation required...)
  deserialize(input: any): SystemFile {
    Object.assign(this, input);

    return this;
  } */


}

  // Set the Stats


